<template>
  <div class="main-content">
    <div class="card-header">
      <h5>Редактирование смен менеджеров</h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">

          </div>
        </div>
      </div>
    </div>
    <!--        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>-->
    <div class="card" v-if="!loading && presentGroup">
      <div class="card-body">
        <table class="table table-sm table-striped">
          <tbody>
          <tr v-for="r in records">
            <td>{{ r.id }}</td>
            <td>{{ printDate(r.active_date, 'DD.MM.YYYY') }}</td>
            <td align="right">
              <button @click="showGroup(r.id)" class="btn btn-sm btn-outline-info">посмотреть</button>
            </td>
          </tr>
          <tr>
            <td colspan="10" align="right">
              <button @click="showGroup()" class="btn btn-sm btn-outline-info">создать на основе актуальной группы
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <EditGroup :editGroup="editGroup" :allGroups="allGroups" :allUsers="allUsers" :schedule="shifts"/>
      </div>
    </div>
  </div>
</template>
<script>

import api from "@/api";
import EditGroup from "@/views/users/components/EditGroup.vue";

export default {
  components: {EditGroup},
  data() {
    return {
      loading: false,
      records: null,
      presentGroup: null,
      editGroup: null,
      allGroups: [],
      allUsers: [],
      shifts: [],
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    showGroup(id = null) {
      if (!id) {
        this.editGroup = {data: {...this.presentGroup}};
      } else {
        this.editGroup = this.records.find((g) => g.id === id);
      }
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/new/users/managers/groups/history');
      if (data.success) {
        this.records = data.records;
        this.allGroups = data.all_groups;
        this.allUsers = data.all_users;
        this.shifts = data.shifts;
        this.presentGroup = data.present_group.reduce((acc, g) => {
          acc.push({
            group: data.all_groups.find((gg) => gg.id === g.id),
            to_delete: false,
            schedule: g.work_shift_id,
            users: g.users.reduce((ac, u) => {
              const shift = u.user.details.find((d) => d.alias === 'day_shift_num')?.details;
              const role = u.user.roles.find((d) => d.name === 'manager') ? 'manager' : 'managerAssist';
              ac[`shift_${shift}`].push({id: u.user_id, name: u.user.name, role});
              return ac;
            }, {shift_1: [], shift_2: []})
          })
          return acc;
        }, [])
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>
